import { APP_CONFIG } from "../../config";
import {
  ClientDeviceInfo,
  CookiePreferences,
} from "../../services/Device/Device.interface";
import { Language } from "../../utils/i8n";
interface DeviceState extends ClientDeviceInfo {
  env: string;
  initialized: boolean;
  cookieAgreement: boolean;
  cookiePreferences: CookiePreferences | null;
  languageCode: Language;
}

const defaulteDeviceState: DeviceState = {
  initialized: false,
  cookieAgreement: false,
  cookiePreferences: null,
  languageCode: 'EN',
  env: APP_CONFIG.environment,
};

export { defaulteDeviceState, DeviceState };
